import React from 'react';
import AuthLayout from 'layouts/AuthLayout';

const NotAuthorizedPage = () => {
    return (
        <AuthLayout>
            Not Authorized
        </AuthLayout>
    )
}

export default NotAuthorizedPage;